(function() {
    'use strict';

    angular.module('remitEventsApp').config(function($stateProvider) {
        $stateProvider
            .state('app', {
                abstract: true,
                views: {
                    'menu@': {
                        templateUrl: 'scripts/components/menu/menu.html',
                        controller: 'MenuController',
                        controllerAs: 'menu'
                    },
                    'header@': {
                        templateUrl: 'scripts/components/header/header.html',
                        controller: 'HeaderController',
                        controllerAs: 'header'
                    },
                    'footer@': {
                        templateUrl: 'scripts/components/footer/footer.html',
                        controller: 'FooterController',
                        controllerAs: 'footer'
                    }
                },
                resolve: {
                    authorize: [
                        'Auth',
                        function(Auth) {
                            return Auth.authorize();
                        }
                    ],
                    mainTranslatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }
                    ]
                }
            })
            .state('site', {
                abstract: true,
                parent: 'app',
                views: {
                    'container@': {
                        templateUrl: 'scripts/components/site/site.html',
                        controller: 'SiteController',
                        controllerAs: 'site'
                    }
                }
            });
    });
})();
